import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import GeneralActualCostInfo from './GeneralActualCostInfo';
import SpecificActualCostInfo from './SpecificActualCostInfo';
import Button from '@material-ui/core/Button';
import moment from 'moment';



//Progress
import CircularProgress from '@material-ui/core/CircularProgress';
import {
  CREATE_PROJECT_MODEL_ACTION_CREATE,
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW
} 
from '../common/redux/constantes';

//validators
import {validateField} from '../common/redux/validators';


const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3,
    },
  },
  stepper: {
    padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
});

const steps = [
  'General', 
  'Specific'
];

class CreateActualCost extends Component {
 

  constructor(props)
  {
    super(props);

    //Bindings
    this.handleChange=this.handleChange.bind(this);
    this.saveActualCost=this.saveActualCost.bind(this);
    this.closeDialog = this.closeDialog.bind(this);

    //Primer estado
    let actual_cost = {
      invoice_date:'',
      project:this.props.project,
      commited_date:0
    };
    let activeStep = 0;
    
    //Si está editando o viendo la info
    if(this.props.actionDialog !== CREATE_PROJECT_MODEL_ACTION_CREATE)
    {
      actual_cost = this.props.actualCostEdit;
      this.setState({actual_cost:actual_cost});
    }

    this.state = {
      activeStep: activeStep,
      actual_cost:actual_cost,
      errores:{}
    }; 
  }


  componentDidMount()
  {
    //Consultar los catalogos 
    this.props.actions.fetchReportingPeriods(this.props.project)
    .then(res=>{
      if(res.data.rps && res.data.rps.length>0)
      {
        this.setState({
          reporting_periods:res.data.rps,
        });
      }
    });

    //Consultar los control accounts 
    this.props.actions.fetchControlAccounts(this.props.project)
    .then(res=>{
      if(res.data.control_accounts && res.data.control_accounts.length>0)
      {
        let control_accounts = res.data.control_accounts.map(control_account=>{
          let w = {};
          w.control_account = w.value =control_account.control_account;
          w.name = w.label= control_account.name;
          return w;
        });
        this.setState({
          control_accounts: control_accounts, 
        });
      }
    });
  }

  getStepContent(step) 
  {
    switch (step) {
      case 0:
        return <GeneralActualCostInfo 
              handleChange={this.handleChange} 
              errores={this.state.errores} 
              actual_cost={this.state.actual_cost}
              reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
        case 1:
        return <SpecificActualCostInfo 
              handleChange={this.handleChange} 
              errores={this.state.errores} 
              actual_cost={this.state.actual_cost} 
              reporting_periods={this.state.reporting_periods}
              control_accounts={this.state.control_accounts}
              project={this.props.project}
              reviewActive={(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )}/>;
      default:
        throw new Error('Unknown step');
    }
  }

   handleNext = () => 
   {
    if(steps.length - 1 === this.state.activeStep && this.props.actionDialog!==CREATE_PROJECT_MODEL_ACTION_SHOW)
    {
      //Solo puede guardar si está valido el form
      if(!this.validateForm())
      {
        return;
      }
      //Si es el último step hay que guardar el project. 
      this.saveActualCost();
    }
    else if(steps.length - 1 === this.state.activeStep)
    {
      //Por petición se hizo que si está sólo mostrando datos en el botón next se cierre la pantalla.
      this.props.onCloseAction();
      return;
    }

    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));
  };


  closeDialog()
  {
    this.props.onCloseAction();
  }

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleChange(event) {
    //Si sólo se está mostrando la información no cambia nada.
    if(this.props.actionDialog === CREATE_PROJECT_MODEL_ACTION_SHOW )
      return;

    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    let actual_cost = this.state.actual_cost;
    actual_cost[name] = value;


    if(actual_cost.record_date && actual_cost.control_account)
    {
      let reporting_number = 0;
      let reporting_period_id = 0;
      for(let i=0; i<this.state.reporting_periods.length;i++)
      {
        let reporting_period = this.state.reporting_periods[i];
        if(moment(this.state.actual_cost.record_date).isBetween(reporting_period.start_date,reporting_period.end_date, null, '[]') && reporting_period.control_account === this.state.actual_cost.control_account)
        {
          reporting_number = reporting_period.reporting_number;
          reporting_period_id = reporting_period.reporting_period;
        }
      }
      
      if(reporting_number === 0)
      {
        reporting_number = "A new RP will be created.";
      }
      else
        reporting_number = "#" + reporting_number;

      actual_cost["reporting_period"] = reporting_period_id;
      actual_cost["reporting_number"] = reporting_number;
    }


    this.setState({
      actual_cost: actual_cost,
    });
    this.validateForm();
  }

  validateForm = ()=>{
    let errores = {};
    let valido = true;
    let actual_cost = {
      invoice_date:'',
      record_date:'',
      commited_date:'',
      control_account:'',
      total_cost:'',
      inv_number:'',
      company:'',
      contract_number:'',
      contract:'',
      account:''
    };

    // if(this.state.actual_cost.reporting_period === 0)
    // {
    //   errores["record_date"] = "Invalid date";
    //   valido = false;
    // }

    //Validando atributos almenos ingresados
    for (const attribute in actual_cost) 
    {
      if (!validateField(this.state.actual_cost[attribute])) 
      {
        errores[attribute]= 'Required field';
        valido = false;
      }
    }

    this.setState({
      errores: errores,
    });
    return valido;
  }

  saveActualCost()
  {
    this.props.actions.saveActualCost(this.state.actual_cost,this.props.actionDialog );
  }

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const {savePending, fragmentContent,fragmentTitle } = this.props.actual;
    const {activeStep} = this.state;
    let title = "Actual Cost Information";
    if(this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE){
      title =  "Create Actual Cost";
    }else if (this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_EDIT){
      title = "Update Actual Cost";
    }
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              {title}
            </Typography>
            <Stepper activeStep={activeStep} className={classes.stepper}>
              {steps.map(label => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <React.Fragment>
              {activeStep === steps.length ? (
                <div>
                  {savePending ? 
                  (
                    <CircularProgress />
                  ):(
                    <React.Fragment>
                      <Typography variant="h5" gutterBottom>
                        {fragmentTitle}
                      </Typography>
                      <Typography variant="subtitle1" color={this.props.actual.saveActualCostError===-1?"secondary":"initial"}>
                      {fragmentContent}
                      </Typography>
                      <br/>
                      {this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_CREATE && this.props.actual.saveActualCostError!==-1?
                        (
                          <div>
                            <Typography variant="subtitle1">
                              Do you want to add the cost to other Control Account?
                            </Typography>
                            <Button
                              onClick={this.handleReset}
                              className={classes.button}
                              color="primary"
                            >
                              Yes
                            </Button>
                            <Button
                              onClick={this.closeDialog}
                              className={classes.button}
                              color="primary"
                            >
                              No
                            </Button>
                          </div>
                        ):null
                      }
                    </React.Fragment>
                  )}
                </div>
              ) : (
                <React.Fragment>
                  {this.getStepContent(activeStep)}
                  <div className={classes.buttons}>
                    {(activeStep !== 0) && (
                      <Button
                        onClick={this.handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                    )}
                    {(true) && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleNext}
                        className={classes.button}
                      > 
                        {activeStep === steps.length - 1 ? this.props.actionDialog===CREATE_PROJECT_MODEL_ACTION_SHOW? "Close":"Save" : "Next"}
                      </Button>
                    )}
                  </div>
                </React.Fragment>
              )}
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

CreateActualCost.propTypes = {
  classes: PropTypes.object.isRequired,
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    actual: state.actual,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CreateActualCost));



// WEBPACK FOOTER //
// ./src/features/actual/CreateActualCost.js